import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:before {\n    position: absolute;\n    content: '•';\n    border-radius: 50%;\n    left: 0;\n    top: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  &:before {\n    position: absolute;\n    counter-increment: number;\n    content: counter(number) '.';\n    font-weight: 500;\n    left: 0;\n    top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  p {\n    margin: 0;\n\n    font-size: inherit;\n    line-height: inherit;\n  }\n\n  ul & {\n    ",
        "\n  }\n\n  ol & {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import styled, { css } from "styled-components";
import { Text } from "../../text";
var defaultStyles = {
    position: "relative",
    marginBottom: 16,
    paddingLeft: 32,
    "&:last-child": {
        marginBottom: 0
    },
    "&:before": {
        position: "absolute"
    }
};
var bulletItem = css(_templateObject());
var numbersItem = css(_templateObject1());
var ListItem = styled(Text).attrs(function(param) {
    var _$styles = param.$styles, $styles = _$styles === void 0 ? {} : _$styles;
    return {
        as: "li",
        $styles: _object_spread({}, defaultStyles, $styles)
    };
}).withConfig({
    componentId: "sc-f0f4c986-0"
})(_templateObject2(), bulletItem, numbersItem);
export default ListItem;
